import "./Home.css";
import React from "react";
import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import {Role} from "../../Utils/enums";
import Header from "../Header";
import CSIAssign from "./CSIAssignScreen/CSIAssign";
import UsersPage from "./UsersManagementScreen/Users";
import KeywordsManagement from "./KeywordsManagementScreen/KeywordsManagement";
import Menu from "./MenuScreen/Menu";

const Home = ({role, setRole, myUserId, setMyUserId}: {role: Role, setRole: React.Dispatch<React.SetStateAction<Role>>, myUserId: number, setMyUserId: React.Dispatch<React.SetStateAction<number>>}) => {
    const location = useLocation();
    
    return (
        <div className="home-page">
            <Header setRole={setRole} setUserId={setMyUserId}/>
            <Routes>
              <Route path="/" element={<Menu role={role} />} />
              <Route path="/kw-csi-assign" element={<CSIAssign is_ai={false}/>} />
              <Route path="/ai-csi-assign" element={<CSIAssign is_ai={true}/>} />
              <Route path="/admin-users" element={<UsersPage role={role} myUserId={myUserId}/>} />
              <Route path="/admin-keywords" element={<KeywordsManagement />} />
              <Route path="/login" element={<Navigate to={new URLSearchParams(location.search).get('redirect') || "/"}/>} />
              <Route path="*" element={<PageNotFound/>} />
            </Routes>
        </div>
    );
};

const PageNotFound = () => {
    return (
        <div className="empty-page">
            <h3 className="empty-page-title">404: Such page is not found</h3>
        </div>
    );
};

// const PageInDevelopment = () => {
//     return (
//         <div className="empty-page">
//             <h3 className="empty-page-title">Sorry, this page is still in development.</h3>
//         </div>
//     );
// };

export default Home;